 /************** New Arrival *************/ 
function initCusArrivals() {
  var $slider = $('[data-cus-arrivals-slider]');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 4.2,
    slidesToScroll: 1,
    infinite: false,
    initialSlide: 0,
    centerMode: false,
    arrows: true,
    prevArrow: $('[data-cus-arrivals-prev]'),
    nextArrow: $('[data-cus-arrivals-next]'),
    dots: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 400,
    cssEase: 'ease',
    swipeToSlide: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.25,
          arrows: false
        }
      }
    ]
  });
}

$(document).ready(initCusArrivals);
document.addEventListener('shopify:section:load', initCusArrivals);

$(window).on('resize', function () {
  clearTimeout(window.cusArrivalsResize);

  window.cusArrivalsResize = setTimeout(function () {
    initCusArrivals();
  }, 200);
});





 /************** Artist *************/ 
$(document).ready(function () {
 $('.cus-meet-maker__artists').slick({
    slidesToShow:4,
    slidesToScroll:1,
    infinite:true,
    arrows:true,
    prevArrow:$('.cus-meet-maker__arrow--prev'),
    nextArrow:$('.cus-meet-maker__arrow--next'),
    dots:false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 400,
    cssEase: 'ease',
    swipeToSlide: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });

  /************** Wishlist Start *************/ 
  $(document).on('click', '.wishlist-btn', function(){
    var btn = $(this);
    var product = {
      id: btn.data('product-id'),
      title: btn.data('product-title'),
      url: btn.data('product-url'),
      image: btn.data('product-image'),
      price: btn.data('product-price')
    };
    var wishlist = JSON.parse(localStorage.getItem('shopifyWishlist')) || [];
    var exists = wishlist.findIndex(function(item){
      return item.id == product.id;
    });
    if(exists > -1){
      wishlist.splice(exists, 1);
      btn.removeClass('active');
    } else {
      wishlist.push(product);
      btn.addClass('active');
    }
    localStorage.setItem('shopifyWishlist', JSON.stringify(wishlist));
    $('.cus-header__wishlist .cstm_wishlishtcount').text(wishlist.length);
  });
  /************** Wishlist End **************/ 
  /********************************************/
  $('.predictive-search-form__content-wrapper').hide();
  $('.search-input').click(function () {
      $('.predictive-search-form__content-wrapper').show();
  }); 
  $(document).on('click', '#MainContent', function(){
      $('.predictive-search-form__content-wrapper').hide();
  });
  /********************************************/
  $('.cstm-sharetooltip').hide();
  $('.cus-product-action-share').on('click', function(){
    var url = $(this).data('producturl');
    navigator.clipboard.writeText(url).then(function(){
      $('.cstm-sharetooltip').show().text('Copied');
      setTimeout(function(){
        $('.cstm-sharetooltip').text('').hide();
      }, 2000);
    });
  });
  /********************************************/
  /********************************************/
  var getWishListLength = JSON.parse(localStorage.getItem('shopifyWishlist')) || [];
  $('.cus-header__wishlist .cstm_wishlishtcount').text(getWishListLength.length);
  /********************************************/
  /********************************************/
   var getWishList = JSON.parse(localStorage.getItem('shopifyWishlist')) || [];
   var wishlistIds = getWishList.map(function(item) {
        return parseInt(item.id);
    });
    $('.check_productonwL').each(function () {
        var $item = $(this);
        var checkId = parseInt($item.data('productid'));
        if (wishlistIds.includes(checkId)) {
            $item.find('.wishlist-btn').addClass('active');
        }
    });
  /********************************************/

  /********************************************/
  $('.cstm_rfq_btn').click(function(e){
    e.preventDefault();
    $('.cstm_popup_rfq_form_frotradec').show();
  });
  $('.close_btn_popup').click(function(e){
    e.preventDefault();
    $('.cstm_popup_rfq_form_frotradec').hide();
  });
  /********************************************/

});






 /************** journal *************/ 
(function () {
  function loadSubstackPosts() {
    document.querySelectorAll("[id^='substack-posts-']").forEach(function (wrapper) {
      var sectionId = wrapper.id.replace("substack-posts-", "");
      var settings = window.substackSettings && window.substackSettings[sectionId];

      if (!settings) return;

      var limit = parseInt(settings.limit, 10) || 3;
      var callbackName = "substackCallback_" + sectionId.replace(/[^a-zA-Z0-9_]/g, "");

      window[callbackName] = function (data) {
        try {
          if (!data || data.status !== "ok" || !data.items) {
            wrapper.innerHTML = "<p>No journal posts found.</p>";
            cleanup();
            return;
          }

          var html = "";

          data.items.slice(0, limit).forEach(function (post) {
            var image = post.thumbnail || "";

            if (!image && post.content) {
              var imgMatch = post.content.match(/<img[^>]+src=["']([^"']+)["']/i);

              if (imgMatch) {
                image = imgMatch[1];
              }
            }

            var description = post.description || "";

            description = description
              .replace(/<[^>]*>/g, "")
              .replace(/\s+/g, " ")
              .trim();

            var safeTitle = escapeHtml(post.title || "");
            var safeDescription = escapeHtml(description);
            var safeLink = escapeAttribute(post.link || "#");
            var safeImage = escapeAttribute(image);

            html +=
              '<article class="cus-substack-card">' +
                '<div class="cus-substack-card__image">' +
                  (image
                    ? '<img src="' + safeImage + '" alt="' + safeTitle + '" loading="lazy">'
                    : "") +
                '</div>' +
                '<div class="cus-substack-card__content">' +
                  '<div class="cus-substack-card__tag">Journal</div>' +
                  '<h3 class="cus-substack-card__title">' +
                    '<a href="' + safeLink + '" target="_blank" rel="noopener noreferrer">' +
                      safeTitle +
                    '</a>' +
                  '</h3>' +
                  '<p class="cus-substack-card__description">' +
                    safeDescription.substring(0, 160) +
                    (description.length > 160 ? "..." : "") +
                  '</p>' +
                  '<a href="' + safeLink + '" target="_blank" rel="noopener noreferrer" class="cus-substack-card__read">' +
                    'READ MORE' +
                  '</a>' +
                '</div>' +
              '</article>';
          });

          wrapper.innerHTML = html || "<p>No journal posts found.</p>";

          cleanup();
        } catch (error) {
          console.error("Substack Render Error:", error);
          wrapper.innerHTML = "<p>Error loading posts</p>";
          cleanup();
        }
      };

      function cleanup() {
        var script = document.getElementById(callbackName + "_script");

        if (script) {
          script.remove();
        }

        try {
          delete window[callbackName];
        } catch (e) {
          window[callbackName] = undefined;
        }
      }

      var apiUrl =
        "https://api.rss2json.com/v1/api.json" +
        "?rss_url=" + encodeURIComponent("https://cleocollects.substack.com/feed") +
        "&api_key=b7mrdgz0fsrezvkbdyutrcdr8ehbjwpwh0qrx7fk" +
        "&count=500" +
        "&callback=" + encodeURIComponent(callbackName);

      var script = document.createElement("script");

      script.id = callbackName + "_script";
      script.src = apiUrl;
      script.async = true;

      script.onerror = function () {
        console.error("Substack JSONP Error");
        wrapper.innerHTML = "<p>Error loading posts</p>";
        cleanup();
      };

      document.head.appendChild(script);

      setTimeout(function () {
        if (window[callbackName]) {
          return;
        }

        if (!wrapper.innerHTML.trim()) {
          wrapper.innerHTML = "<p>Error loading posts</p>";
        }
      }, 15000);
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadSubstackPosts);
  } else {
    loadSubstackPosts();
  }
})();





